<div class="pinned-card" *ngIf="user" (click)="open()">
    <button type="button" class="dismiss" (click)="clear($event)" aria-label="Unpin">
      <nb-icon icon="close-outline" pack="eva"></nb-icon>
    </button>
  
    <div class="name">{{ displayName || 'Pinned user' }}</div>
    <div class="line" *ngIf="user.email">{{ user.email }}</div>
    <div class="line muted">ID: {{ user.documentId }}</div>
  </div>